import { Injectable, inject, signal, Signal } from "@angular/core";
import { Observable, Subscription, timer, switchMap, shareReplay, catchError, throwError } from "rxjs";
import { PlanTemplateDto } from "../../api/models/fraud.models";
import { ApiService } from "../../api/services/api.service";

@Injectable({
  providedIn: 'root',
})
export class PlanTemplatesService {
  private static readonly REFRESH_INTERVAL_MS = 30_000;
  private readonly _apiService = inject(ApiService);
  private readonly _planTemplates = signal<PlanTemplateDto[]>([]);
  private _planTemplates$?: Observable<PlanTemplateDto[]>;
  private _planTemplatesSubscription?: Subscription;

  public readonly planTemplates: Signal<PlanTemplateDto[]> = this._planTemplates.asReadonly();

  public getPlanTemplates(): Observable<PlanTemplateDto[]> {
    if (!this._planTemplates$) {
      this._planTemplates$ = timer(0, PlanTemplatesService.REFRESH_INTERVAL_MS).pipe(
        switchMap(() => this._apiService.getPlanTemplates()),
        shareReplay({ bufferSize: 1, refCount: false }),
        catchError((error) => {
          this._planTemplates$ = undefined;
          return throwError(() => error);
        }),
      );
    }

    return this._planTemplates$;
  }

  public startPlanTemplatesSync(): void {
    if (this._planTemplatesSubscription) {
      return;
    }

    this._planTemplatesSubscription = this.getPlanTemplates().subscribe({
      next: (planTemplates) => this._planTemplates.set(planTemplates),
      error: (error) => console.error('getPlanTemplates', error),
    });
  }

  public clearCache(): void {
    this._planTemplatesSubscription?.unsubscribe();
    this._planTemplatesSubscription = undefined;
    this._planTemplates$ = undefined;
    this._planTemplates.set([]);
  }
}
